import script from "./DesignPagina.vue?vue&type=script&setup=true&lang=js"
export * from "./DesignPagina.vue?vue&type=script&setup=true&lang=js"

import "./DesignPagina.vue?vue&type=style&index=0&id=3974462a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3974462a"]])

export default __exports__